import React, { useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import PreviewModule from '../../modules/preview/Module'

import useSession from '../../session/useSession'
import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'

import { IAction, SurveyMode } from '../types'

import { Button } from 'primereact/button'

import style from './style.module.scss'
import previewToolbarStyles from '../../modules/preview/components/PreviewToolbar.module.scss'

export interface EndViewProps {
  action: IAction
}

export default function EndView({ action }: EndViewProps) {
  const [showRedirect, setShowRedirect] = useState(true)
  const session = useSession()
  const { t } = useInterfaceLocale()

  const endMessageText = useRef('')
  if ('' === endMessageText.current) {
    endMessageText.current = action.gdpr_status
      ? action.end_text
      : session.endText || action.end_text || t('end', 'text')
  }
  const endMessage = {
    text: action.gdpr_status ? action.end_text : session.endText || action.end_text || t('end', 'text'),
    ...(!action.gdpr_status && !session.endText && action.end_text ? { fromAction: true } : {})
  }
  // fromAction param added for the styling purpose when we get text from the action and don't show Thank you title
  // for example when Survey is Closed or processing

  if (endMessage.fromAction) {
    session.applyCustomStyle({ pb: false })
  }

  return (
    <div className={style.EndView} data-testid="SW-End-View">
      <div className={style.content}>
        {endMessage.fromAction ? (
          <div
            className={style.subtitle}
            data-testid="SW-End-Text"
            dangerouslySetInnerHTML={{ __html: endMessageText.current }}
          />
        ) : (
          <>
            <div className={style.title} data-testid="SW-End-Title">
              {t('end', 'title')}
            </div>
            <p
              className={style.text}
              data-testid="SW-End-Text"
              dangerouslySetInnerHTML={{ __html: endMessageText.current }}
            />
          </>
        )}
      </div>
      {PreviewModule.customAreaRef.current &&
      SurveyMode.RESPONDENT === action.mode &&
      action.redirect_url?.length &&
      showRedirect
        ? createPortal(
            <div className={style.redirectArea}>
              <div className={previewToolbarStyles.header} data-testid="SW-Preview-Redirect-Text">
                <div className={previewToolbarStyles.headerTitle}>{t('preview', 'redirect', 'title')}</div>
                <a
                  className={previewToolbarStyles.headerSubtitle}
                  href={action.redirect_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {action.redirect_url}
                </a>
              </div>
              <div className={previewToolbarStyles.body}>
                <Button
                  label={t('preview', 'redirect', 'dismiss')}
                  aria-label={t('preview', 'redirect', 'dismiss')}
                  onClick={() => void setShowRedirect(false)}
                  className="p-button-secondary"
                  data-testid="SW-Preview-Redirect-Dismiss"
                />
                <a
                  href={action.redirect_url}
                  target="_blank"
                  rel="noreferrer"
                  className="p-button p-button-primary"
                  data-testid="SW-Preview-Redirect-Follow"
                >
                  {t('preview', 'redirect', 'open')}
                </a>
              </div>
            </div>,
            PreviewModule.customAreaRef.current
          )
        : null}
    </div>
  )
}
